import {Checkbox, Divider, Grid, List, ListSubheader, MenuItem} from "@mui/material";
import {red} from "@mui/material/colors";
import {PopoutMenu} from "./library/PopoutMenu";
import React, {useContext, useState} from "react";
import {ConfirmContext} from "../../../../misc/Confirm";
import {EditHardwareItem} from "./HwEditingContextProvider";
import {ChangePreviewContext} from "../ShopDrawingChangePreview";
import {useSupplierCategories} from "./SupplierContext";
import {ManageProjectSuppliers} from "./ManageProjectSuppliers";
import {useReloader} from "./ReloadContext";

export function HardwareItemMenu(props: {
    value: EditHardwareItem;
    disabled?: boolean;
    onChange(value: EditHardwareItem): void;
}) {
    const confirm = useContext(ConfirmContext);
    const locked = useContext(ChangePreviewContext).enabled;
    const suppliers = useSupplierCategories();
    const [manageOpen, setManageOpen] = useState(false);
    const reload = useReloader();

    // only top-level (parent) categories are user-selectable; the by-series child is
    // derived on the server (calc_supplier_category)
    const parentSuppliers = (suppliers.list || [])
        .filter(s => s.parent === null)
        .sort((a, b) => a.sortOrder - b.sortOrder);

    return (
        <>
            <PopoutMenu size="small" disabled={props.disabled}>
                {onClose => <>
                    <List>
                        <ListSubheader>Supplied By</ListSubheader>
                        {parentSuppliers.map(s => (
                            <MenuItem key={s.id} disabled={locked} style={{padding: 4, paddingRight: 24, paddingLeft: 4}} onClick={() => {
                                onClose();
                                props.onChange(Object.assign({}, props.value, {
                                    supplierCategory: s.id,
                                    supplierCategoryName: s.name,
                                }));
                            }}>
                                <Grid container spacing={1} alignItems="center">
                                    <Grid item>
                                        <Checkbox disabled={locked} checked={props.value.supplierCategory === s.id} onChange={() => {}} />
                                    </Grid>
                                    <Grid item>
                                        {s.name} {s.byUs ? "(Us)" : ""}
                                    </Grid>
                                </Grid>
                            </MenuItem>
                        ))}
                        <Divider />
                        <MenuItem disabled={locked} onClick={() => {
                            onClose();
                            setManageOpen(true);
                        }}>Edit Supplied Categories</MenuItem>
                        <MenuItem disabled={locked} style={{color: red["800"]}} onClick={async () => {
                            onClose();

                            const ok = await confirm.confirm("Are you sure you want to remove this group?")
                            if(!ok) return;

                            props.onChange(Object.assign({}, props.value, {
                                activeQty: 0,
                                inactiveQty: 0,
                                commonQty: 0,
                            }));

                        }}>Remove</MenuItem>
                    </List>
                </>}
            </PopoutMenu>
            {manageOpen && <ManageProjectSuppliers onDone={() => {
                setManageOpen(false);
                suppliers.reload();
                reload.current();
            }} />}
        </>
    )
}